import { useEffect, useRef, useState } from "react";
import { FaHome } from "react-icons/fa";
import { FaPhone } from "react-icons/fa6";
import { FaUser } from "react-icons/fa";
function ContactMarquee({ addressVal, phoneVal  ,cousinName,ledgerSubGroupName,ledgerSubGroupNameInHindi,tableColumn,firstName,secondName}) {
  // console.log("check name in hindi", firstName,secondName) 
  const containerRef = useRef(null);
  const [isOverflowing, setIsOverflowing] = useState(false);
       const storedLang = JSON.parse(localStorage.getItem("second_language"));
   const language = storedLang?.language || "en";
  useEffect(() => {
    const el = containerRef.current;
    if (!el) return;

    const checkOverflow = () => {
      setIsOverflowing(el.scrollWidth > el.clientWidth);
    };

    checkOverflow();

    // Optional: re-check when window resizes
    window.addEventListener("resize", checkOverflow);
    return () => window.removeEventListener("resize", checkOverflow);
  }, [addressVal, phoneVal, cousinName, ledgerSubGroupName, tableColumn,ledgerSubGroupNameInHindi,firstName,secondName]);

  return (
    (addressVal || phoneVal || cousinName || ledgerSubGroupName || ledgerSubGroupNameInHindi) ? (
      <div
        ref={containerRef}
        className="relative  overflow-hidden whitespace-nowrap w-full cursor-pointer "
      >
        <div
          className={`text-sm flex gap-3  justify-start  px-1 ${
            isOverflowing ? "animate-marquee" : ""
          }`}
        >
           {language !== "en" && (cousinName && (
            <div className="font-medium flex gap-1">
              <FaUser className="text-[12px] mt-[2.5px]" /> {cousinName}
            </div>
          ))}
           {ledgerSubGroupName && (
            <div className="font-medium ">
              {ledgerSubGroupName}
            </div>
          )}
           {language !== "en" &&  (ledgerSubGroupNameInHindi && (
            <div className="font-medium ">
              {ledgerSubGroupNameInHindi}
            </div>
          ))}
          {phoneVal && (
            <div className="font-medium flex gap-1 ">
              <FaPhone className="text-[12px] mt-[2.5px]" /> {phoneVal}
            </div>
          )}
          {addressVal && (
            <div className="flex gap-1">
              <FaHome className="text-[14px] mt-[2px]" /> {addressVal}
            </div>
          )}
          {isOverflowing && (

            <>
              {language !== "en" && (cousinName && (
                <div className="flex gap-1 ">
                  <FaUser className="text-[14px] mt-[2px]" /> {cousinName}
                </div>
              ))}
              {ledgerSubGroupName && (
            <div className="font-medium ">
              {ledgerSubGroupName}
            </div>
          )}
           { language !== "en" && (ledgerSubGroupNameInHindi && (
            <div className="font-medium ">
              {ledgerSubGroupNameInHindi}
            </div>
          ))}

              {phoneVal && (
                <div className="font-medium flex gap-1 ">
                  <FaPhone className="text-[12px] mt-[2.5px]" /> {phoneVal}
                </div>
              )}
              {addressVal && (
                <div className="flex gap-1">
                   <FaHome className="text-[14px] mt-[2px]" /> {addressVal}
                </div>
              )}

            </>
          )}
        </div>
      </div>
    ) :
      (
      <div
        ref={containerRef}
        className="relative  overflow-hidden whitespace-nowrap w-full cursor-pointer "
      >
        <div
          className={`text-sm flex gap-3  justify-start px-1 ${
            isOverflowing ? "animate-marquee" : ""
          }`}
        >
           {tableColumn && (
            <div className="font- flex gap-1 ">
              {/* <FaUser className="text-[12px] mt-[2.5px]" />  */}
              {tableColumn}
            </div>
          )}
           {firstName && (
            <div className="font- flex  text-sm gap-1">
              {/* <FaUser className="text-[12px] mt-[2.5px]" />  */}
              {firstName}
            </div>
          )}
           {language !== "en" &&  (secondName && (
            <div className="font- flex text-sm gap-1">
              {/* <FaUser className="text-[12px] mt-[2.5px]" />  */}
              {secondName}
            </div>
          ))}
          {isOverflowing && (

            <>
              {tableColumn && (
                <div className="flex gap-1 ">
                  {/* <FaUser className="text-[14px] mt-[2px]" /> */}
                   {tableColumn}
                </div>
              )}
              {firstName && (
                <div className="flex text-sm gap-1 ">
                  {/* <FaUser className="text-[14px] mt-[2px]" /> */}
                   {firstName}
                </div>
              )}
               { language !== "en" &&  (secondName && (
                <div className="flex text-sm gap-1 ">
                  {/* <FaUser className="text-[14px] mt-[2px]" /> */}
                   {secondName}
                </div>
              ))}
              {/* {ledgerSubGroupName && (
            <div className="font-medium ">
              ({ledgerSubGroupName})
            </div>
          )} */}

              {/* {tableColumn && (w
                <div className="font-medium flex gap-1 ">
                  <FaPhone className="text-[12px] mt-[2.5px]" />
                   {tableColumn}
                </div>
              )}
              {tableColumn && (
                <div className="flex gap-1">
                   <FaHome className="text-[14px] mt-[2px]" /> 
                   {tableColumn}
                </div>
              )} */}

            </>
          )}
        </div>
      </div>
    )
  );
}

export default ContactMarquee;
